import type { IconName } from '@getaccept/fried-tofu';

export enum TimelineEventCategory {
  General = 'general',
  Chat = 'chat',
  Updates = 'updates',
  Comments = 'comments',
  Map = 'map',
  Files = 'files',
}

export type TimelineEventMetadata = { icon: IconName; name: string } | null;
